import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import { connect } from "react-redux";
import StarsIcon from "@mui/icons-material/Stars";
import {
  addLoyalty,
  getLoyaltyCashback,
  getLoyaltyPercentage,
} from "./Loyalty.services";
import { LOYALTY, PRIMARY, WHITE } from "../../constants";
import styles from "./Loyalty.style";
import { Button } from '@dishopsaas/design-system'
import { displayPriceFormat, isStringNotNull } from "../../utils";
import Spinner from "../Spinner";

const INITIAL_STATE = {
  border: "transparent",
  promoCode: "",
  loadingPromotion: false,
};
class Loyalty extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  render() {
    const { user, secondaryColor, loyalty, loyaltyShop, totalProductPrice } =
      this.props;
    const loyaltyCashback = getLoyaltyCashback(loyalty);
    const { loadingPromotion } = this.state;
    const { loyaltyButton } = styles(secondaryColor);
    let classProgress = "col-12 mt-2";
    if (user?.points >= loyaltyCashback?.limit) {
      classProgress = "col-7 col-sm-9 align-self-center";
    }
    return (
      <>
        <style type="text/css">
          {`
            .dishop-iso .progress-bar
             {
               background-color: ${secondaryColor} ;
             }
          `}
        </style>
        {loyaltyCashback && (
          <div className="row mb-3">
            <div className="col-12">
              <StarsIcon
                style={styles(secondaryColor).starsIcon}
                className="mr-2 mb-1"
              />
              <b>
                Fidélité :{" "}
                {displayPriceFormat(
                  loyaltyCashback.limit * loyaltyCashback.pointsPerEuro,
                  false
                )}{" "}
                offerts pour {displayPriceFormat(loyaltyCashback.limit, false)}{" "}
                d'achat
              </b>
            </div>

            <div className="col-12">
              <div style={{ display: "flex" }}>
                <div className={classProgress}>
                  <ProgressBar
                    striped
                    animated
                    style={styles(secondaryColor).progressBar}
                    label={
                      isStringNotNull(user.points)
                        ? `${getLoyaltyPercentage(
                            user.points,
                            loyaltyCashback
                          )}%`
                        : "0%"
                    }
                    max={loyaltyCashback.limit}
                    now={isStringNotNull(user.points) ? user.points : "0"}
                  />
                </div>
                {user.points >= loyaltyCashback.limit && (
                  <div className="col-5 col-sm-3 justify-content-end input-group-append ml-auto">
                    <Button
                      colorType={PRIMARY}
                      className="col-10 d-flex align-items-center justify-content-center"
                      style={loyaltyButton}
                      onClick={() => {
                        addLoyalty(
                          this,
                          LOYALTY,
                          totalProductPrice,
                          loyaltyShop
                        );
                      }}
                    >
                      {loadingPromotion && <Spinner color={WHITE} size="sm" />}
                      {!loadingPromotion && (
                        <div>
                          <span>Utiliser</span>
                        </div>
                      )}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = ({
  configurationReducer,
  userReducer,
  shopReducer,
}) => {
  const { secondaryColor, loyalty, name, companyId } = configurationReducer;
  const { loyalty: loyaltyShop, shopId } = shopReducer;
  const { user, shopIds } = userReducer;
  return {
    secondaryColor,
    loyalty,
    user,
    customerId: user.customerId,
    name,
    loyaltyShop,
    companyId,
    shopId,
    shopIds,
  };
};

export default connect(mapStateToProps, {})(Loyalty);
